<template>
	<section class="facilities main-content">
		<div class="row">
			<div class="columns column12 align-center">
				<h2>
					{{ facilities.header }}
					<span class="bold">{{ facilities.subtitle }}</span>
				</h2>
			</div>
		</div>
		<div class="row">
			<div class="columns column12 align-center">
				<ul class="facilities">
					<li v-for="item in facilities.facilities" :key="item.ID">
						<font-awesome-icon :icon="`fal fa-${item.icon}`" size="1x" />
						<span>{{ item.content }}</span>
					</li>
				</ul>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	facilities: { type: Object, default: () => ({}) },
});
</script>

<style lang="scss" scoped>
ul {
	list-style: none;
	font-size: calc(var(--body-font-size) + 2px);
	border-top: 1px solid var(--body-color);
	padding: 0;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-between;
	align-items: center;
}

li {
	position: relative;
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	padding: 18px 0;
	border-bottom: 1px solid var(--body-color);
	text-align: left;
	width: 48%;

	svg {
		font-size: 22px;
	}

	span {
		width: calc(100% - 25px);
		padding: 0 0 0 20px;
	}
}

@media (max-width: 800px) {
	li {
		width: 100%;
	}
}
</style>
